module.exports = __webpack_public_path__ + "img/no refunds.49c272b3.png";